module.exports = {"38x379": __webpack_public_path__ + "images/fuel-gauge-back-379x38.png"};